exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".iconButton {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n  padding: 0.1rem 0.2rem;\r\n  box-sizing: border-box;\r\n  cursor: pointer;\r\n}\r\n.iconButton .material-icons {\r\n  margin-right: 0.5rem;\r\n  max-width: 1rem;\r\n  height: 0.5rem;\r\n  font-size: 1rem;\r\n}\r\n.iconButton button {\r\n  border: none;\r\n  background: none;\r\n  padding: 0;\r\n  cursor: pointer;\r\n}", ""]);

// exports
